<template>
  <div v-if="galleryImages && galleryImages.length" class="mt-12">
    <h3 class="text-2xl font-bold mb-6 text-center text-gray-800"> {{ $t('property_detail.property.gallery_title') }}</h3>

    <div :id="galleryID" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      <a
        v-for="(image, index) in imagesData"
        :key="index"
        :href="image.largeURL"
        :data-pswp-width="image.width"
        :data-pswp-height="image.height"
        target="_blank"
        rel="noreferrer"
      >
        <img
          :src="image.thumbnailURL"
          alt="Фото квартиры"
          loading="lazy"
          :class="['fade-img']"
          @load="onImageLoad($event)"
          :style="{ width: width, height: height }"
        />
      </a>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'

const props = defineProps({
  galleryImages: {
    type: Array,
    default: () => []
  },
  width: {
    type: String,
    default: '100%' // можно передавать например '200px'
  },
  height: {
    type: String,
    default: 'auto' // или фиксировать, например '150px'
  }
})

const onImageLoad = (event) => {
  event.target.classList.add('loaded')
}

const galleryID = 'property-gallery'
const lightbox = ref(null)

const imagesData = props.galleryImages.map(url => ({
  largeURL: url,
  thumbnailURL: url,
  width: 1200,
  height: 800
}))

onMounted(() => {
  if (!lightbox.value) {
    lightbox.value = new PhotoSwipeLightbox({
      gallery: '#' + galleryID,
      children: 'a',
      pswpModule: () => import('photoswipe')
    })
    lightbox.value.init()
  }
})

onBeforeUnmount(() => {
  if (lightbox.value) {
    lightbox.value.destroy()
    lightbox.value = null
  }
})
</script>
<style scoped>
.fade-img {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.fade-img.loaded {
  opacity: 1;
}
</style>
